import MiwiFeatureAppLoader from './MiwiFeatureAppLoader'
import miwiFeatureAppLoaderContainer from './miwiFeatureAppLoaderContainer'

export default miwiFeatureAppLoaderContainer(MiwiFeatureAppLoader)
